// extracted by mini-css-extract-plugin
var _1 = "SelectedLabel_selected__2b752";
var _2 = "SelectedLabel_selectedLabel__75f83";
export { _1 as "selected", _2 as "selectedLabel" }
